import React from 'react';
import { motion } from 'framer-motion';
export function BonusesSection() {
  const bonuses = [{
    title: 'Bonus 1: Calendario Productivo Anual',
    desc: "La guía definitiva mes a mes para tu región. Nunca más te preguntes '¿qué planto ahora?'."
  }, {
    title: 'Bonus 2: Fertilizantes Naturales & Bioinsumos',
    desc: 'Recetas caseras para nutrir tu suelo sin gastar una fortuna en productos químicos.'
  }, {
    title: 'Bonus 3: Mini Invernadero Low Cost',
    desc: 'Construye tu propio invernadero con materiales económicos y protege tu huerta del frío.'
  }];
  return <section className="py-16 px-4 bg-black relative overflow-hidden" data-id="element-26">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-27">
        <div className="text-center mb-10" data-id="element-28">
          <motion.span animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="inline-block px-4 py-1 rounded-full bg-red-600 text-white font-bold text-sm mb-4 shadow-[0_0_15px_rgba(220,38,38,0.5)]" data-id="element-29">
            GRATIS POR HOY
          </motion.span>
          <h2 className="text-2xl sm:text-4xl font-bold text-white mb-4" data-id="element-30">
            Llévate estos 3 Regalos Exclusivos
          </h2>
          <p className="text-lg text-zinc-400 max-w-2xl mx-auto" data-id="element-31">
            Herramientas complementarias diseñadas para acelerar tus resultados
            desde el día 1.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-32">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className="bg-zinc-900 rounded-xl p-5 border border-zinc-800" data-id="element-33">
              <div className="flex items-start justify-between gap-2 mb-3" data-id="element-34">
                <h3 className="text-base font-bold text-white leading-tight" data-id="element-35">
                  {bonus.title}
                </h3>
                <span className="shrink-0 bg-green-600 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-36">
                  GRATIS
                </span>
              </div>
              <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-37">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}